import * as marketing from 'services/marketing';

export const Marketing_Agree = 'Marketing_Agree';
export const Marketing_Agree_Check = 'Marketing_Agree_Check';

// 마케팅 정보활용 동의
export const MarketingAgree = (params) => ({
  type: Marketing_Agree,
  payload: {
    promise: marketing.MarketingAgree(params)
  }
});

// 마케팅 정보활용 동의 여부
export const MarketingAgreeCheck = (params) => {
  return {
    type: Marketing_Agree_Check,
    payload: {
      promise: marketing.MarketingAgreeCheck(params)
    }
  };
};
